<template>
    <div class="card">
        <div class="card-header">
            <h5>
                {{ (booking_for == 'affiliate') ? 'Advertisement' : 'Payment' }} Report
            </h5>
        </div>
        <div class="card-body">
            <div class="row">
                <div class="col-md-4">
                    <div class="form-group">
                        <label for="" class="form-label"> Payment for </label>
                        <select class="form-control" placeholder="Booking For" v-model="bookingFor" style="height: 38px;">
                        <option>Select</option>
                        <option value="affiliate">Affiliates</option>
                        <option value="supplier">Suppliers</option>
                        <option value="tour_manager">Tour Managers</option>
                        </select>
                    </div>
                </div>
                <div class="col-md-4" v-if="['supplier','tour_manager','affiliate'].includes(booking_for)">
                  <template v-if="booking_for == 'supplier'">
                    <div class="form-group">
                      <label for="" class="form-label"> Select Suppliers </label>
                      <v-select
                        label="supplier_name"
                        placeholder="Select Suppliers"
                        id="supplier_id"
                        index="id"
                        v-model="supplierId"
                        :options="[
                            { id:0,supplier_name:'All'},
                            ...suppliers
                        ]"
                        multiple
                    />
                    </div>
                  </template>
                  <template  v-if="booking_for == 'tour_manager'">
                    <div class="form-group">
                      <label for="" class="form-label"> Select Tour Managers </label>
                      <v-select
                        label="firstname"
                        placeholder="Select Tour Managers"
                        id="tour_manager_id"
                        index="id"
                        v-model="tourManagerId"
                        :options="[
                            {id:0,firstname:'All'},...tour_managers
                        ]"
                        multiple
                       />
                    </div>
                  </template>
                  <template  v-if="booking_for == 'affiliate'">
                    <div class="form-group">
                      <label for="" class="form-label"> Select Affiliates </label>
                      <v-select
                        label="name"
                        placeholder="Select Affiliates"
                        id="affiliate_id"
                        index="id"
                        v-model="affiliateId"
                        :options="[
                            {id:0,name:'All'},...affiliates
                        ]"
                        multiple
                       />
                    </div>
                  </template>
                </div>
            </div>
            <template v-if="[null,'supplier','tour_manager'].includes(booking_for)">
                <div class="row mt-3">
                    <div class="col-md-12">
                        <div class="row">
                            <div class="col-md-12">
                            <h6> Invoice Deadline Date Range</h6>
                            </div>
                        </div>
                        <div class="row mt-1">
                            <div class="col-md-6">
                            <dateTimePicker
                                no-label
                                label="From Date"
                                id="booking-start-date"
                                format="YYYY-MM-DD"
                                formatted="YYYY-MM-DD"
                                v-model="invoiceDeadlineStartDate.date"
                                :only-date="true"
                                button-color="#ec391e"
                                color="#ec391e"
                                style="border: 1px solid #DFE5F9"
                            />
                            </div>
                            <div class="col-md-6">
                                <dateTimePicker
                                    no-label
                                    label="To Date"
                                    id="booking-end-date"
                                    format="YYYY-MM-DD"
                                    formatted="YYYY-MM-DD"
                                    v-model="invoiceDeadlineEndDate.date"
                                    :only-date="true"
                                    button-color="#ec391e"
                                    color="#ec391e"
                                    style="border: 1px solid #DFE5F9"
                                    :min-date="invoiceDeadlineStartDate.date"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-md-12">
                        <div class="row">
                            <div class="col-md-12">
                            <h6> Payment Date Range</h6>
                            </div>
                        </div>
                        <div class="row mt-1">
                            <div class="col-md-6">
                            <dateTimePicker
                                no-label
                                label="From Date"
                                id="booking-start-date"
                                format="YYYY-MM-DD"
                                formatted="YYYY-MM-DD"
                                v-model="paymentStartDate.date"
                                :only-date="true"
                                button-color="#ec391e"
                                color="#ec391e"
                                style="border: 1px solid #DFE5F9"
                            />
                            </div>
                            <div class="col-md-6">
                                <dateTimePicker
                                    no-label
                                    label="To Date"
                                    id="booking-end-date"
                                    format="YYYY-MM-DD"
                                    formatted="YYYY-MM-DD"
                                    v-model="paymentEndDate.date"
                                    :only-date="true"
                                    button-color="#ec391e"
                                    color="#ec391e"
                                    style="border: 1px solid #DFE5F9"
                                    :min-date="paymentStartDate.date"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <div class="row mt-3">
                    <div class="col-md-12">
                        <div class="row">
                            <div class="col-md-12">
                            <h6> Placement Date Range</h6>
                            </div>
                        </div>
                        <div class="row mt-1">
                            <div class="col-md-6">
                            <dateTimePicker
                                no-label
                                label="From Date"
                                id="booking-start-date"
                                format="YYYY-MM-DD"
                                formatted="YYYY-MM-DD"
                                v-model="placementDeadlineStartDate.date"
                                :only-date="true"
                                button-color="#ec391e"
                                color="#ec391e"
                                style="border: 1px solid #DFE5F9"
                            />
                            </div>
                            <div class="col-md-6">
                                <dateTimePicker
                                    no-label
                                    label="To Date"
                                    id="booking-end-date"
                                    format="YYYY-MM-DD"
                                    formatted="YYYY-MM-DD"
                                    v-model="placementDeadlineEndDate.date"
                                    :only-date="true"
                                    button-color="#ec391e"
                                    color="#ec391e"
                                    style="border: 1px solid #DFE5F9"
                                    :min-date="placementDeadlineStartDate.date"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-md-12">
                        <div class="row">
                            <div class="col-md-12">
                            <h6> Submission Deadline Date Range</h6>
                            </div>
                        </div>
                        <div class="row mt-1">
                            <div class="col-md-6">
                            <dateTimePicker
                                no-label
                                label="From Date"
                                id="booking-start-date"
                                format="YYYY-MM-DD"
                                formatted="YYYY-MM-DD"
                                v-model="placementExpiryStartDate.date"
                                :only-date="true"
                                button-color="#ec391e"
                                color="#ec391e"
                                style="border: 1px solid #DFE5F9"
                            />
                            </div>
                            <div class="col-md-6">
                                <dateTimePicker
                                    no-label
                                    label="To Date"
                                    id="booking-end-date"
                                    format="YYYY-MM-DD"
                                    formatted="YYYY-MM-DD"
                                    v-model="placementExpiryEndDate.date"
                                    :only-date="true"
                                    button-color="#ec391e"
                                    color="#ec391e"
                                    style="border: 1px solid #DFE5F9"
                                    :min-date="placementExpiryStartDate.date"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-md-12">
                        <div class="row">
                            <div class="col-md-12">
                            <h6> Invoice Due Date Range</h6>
                            </div>
                        </div>
                        <div class="row mt-1">
                            <div class="col-md-6">
                            <dateTimePicker
                                no-label
                                label="From Date"
                                id="booking-start-date"
                                format="YYYY-MM-DD"
                                formatted="YYYY-MM-DD"
                                v-model="invoiceDueStartDate.date"
                                :only-date="true"
                                button-color="#ec391e"
                                color="#ec391e"
                                style="border: 1px solid #DFE5F9"
                            />
                            </div>
                            <div class="col-md-6">
                                <dateTimePicker
                                    no-label
                                    label="To Date"
                                    id="booking-end-date"
                                    format="YYYY-MM-DD"
                                    formatted="YYYY-MM-DD"
                                    v-model="invoiceDueEndDate.date"
                                    :only-date="true"
                                    button-color="#ec391e"
                                    color="#ec391e"
                                    style="border: 1px solid #DFE5F9"
                                    :min-date="invoiceDueStartDate.date"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-md-12">
                        <div class="row">
                            <div class="col-md-12">
                            <h6> Payments Date Range</h6>
                            </div>
                        </div>
                        <div class="row mt-1">
                            <div class="col-md-6">
                            <dateTimePicker
                                no-label
                                label="From Date"
                                id="booking-start-date"
                                format="YYYY-MM-DD"
                                formatted="YYYY-MM-DD"
                                v-model="paymentAdvertStartDate.date"
                                :only-date="true"
                                button-color="#ec391e"
                                color="#ec391e"
                                style="border: 1px solid #DFE5F9"
                            />
                            </div>
                            <div class="col-md-6">
                                <dateTimePicker
                                    no-label
                                    label="To Date"
                                    id="booking-end-date"
                                    format="YYYY-MM-DD"
                                    formatted="YYYY-MM-DD"
                                    v-model="paymentAdvertEndDate.date"
                                    :only-date="true"
                                    button-color="#ec391e"
                                    color="#ec391e"
                                    style="border: 1px solid #DFE5F9"
                                    :min-date="paymentAdvertStartDate.date"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </div>
        <div class="card-footer align-items-right">
            <button
                type="submit"
                class="button"
                v-on:click.prevent="generatePaymentReport"
            >
            Generate report    
            </button>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
export default {
    name: 'PaymentReportFields',
    props: {
        suppliers:Array,
        tour_managers:Array, 
        affiliates:Array
    },
    computed: {
        bookingFor: {
            get: function() {
                return this.booking_for;
            },
            set: function (newValue) {
                this.supplier_id = []
                this.tour_manager_id = []
                this.affiliate_id = []
                this.booking_for = newValue
            }
        },
        supplierId: {
            get: function() {
                return this.supplier_id;
            },
            set: function (newValue) {
                if (newValue == 0) {
                    const ids = this.suppliers.map(obj => obj.id);
                    this.supplier_id = ids
                } else {
                    this.supplier_id = newValue
                }
            }
        },
        tourManagerId: {
            get: function() {
                return this.tour_manager_id;
            },
            set: function (newValue) {
                if (newValue == 0) {
                    const ids = this.tour_managers.map(obj => obj.id);
                    this.tour_manager_id = ids
                } else {
                    this.tour_manager_id = newValue
                }
            }
        },
        affiliateId: {
            get: function() {
                return this.affiliate_id;
            },
            set: function (newValue) {
                if (newValue == 0) {
                    const ids = this.affiliates.map(obj => obj.id);
                    this.affiliate_id = ids
                } else {
                    this.affiliate_id = newValue
                }
            }
        }
    },
    data() {
        return {
            booking_for: null,
            supplier_id : null,
            tour_manager_id : null,
            affiliate_id : null,
            invoiceDeadlineStartDate: {},
            invoiceDeadlineEndDate: {},
            paymentStartDate: {},
            paymentEndDate: {},
            placementDeadlineStartDate : {},
            placementDeadlineEndDate : {},
            placementExpiryStartDate : {},
            placementExpiryEndDate: {},
            invoiceDueStartDate : {},
            invoiceDueEndDate: {},
            paymentAdvertStartDate : {},
            paymentAdvertEndDate : {},
        }
    },
    methods: {
        validateFields()
        {
            let This = this

            return new Promise((resolve, reject) => {

                let errorCount = 0;

                // Departure Dates validation
                if(This.booking_for.date && !This.departureDateEnd.date) {
                    This.errors.departuare_end = "Please select a valid departure to date"
                    errorCount +=1
                }else if(This.departureDateEnd.date && !This.departureDateStart.date){
                    This.errors.departure_start = "Please select a valid departure from date"
                    errorCount +=1
                }else{
                    This.errors.departuare_end = null
                    This.errors.departure_start = null
                }

                // Tour Selected 
                if (This.selected_tours.length == 0) {
                    This.errors.selected_tours = "Please select atleast one tour"
                    errorCount +=1
                } else{
                    This.errors.selected_tours = null
                }

                if(errorCount == 0 ){
                    resolve(true)
                }else{
                    reject(true)
                }

            })
        },
        generatePaymentReport () {
            this.$store.dispatch("setLoadStatus");
            axios({
                method:'post',
                url: this.$api + 'reports/payment-report',
                responseType:'arraybuffer',
                data: {
                    report_for: this.booking_for,
                    supplier_id : this.supplier_id,
                    tour_manager_id : this.tour_manager_id,
                    affiliates_id : this.affiliate_id,
                    invoiceDeadlineStartDate : this.invoiceDeadlineStartDate.date,
                    invoiceDeadlineEndDate : this.invoiceDeadlineEndDate.date,
                    paymentStartDate : this.paymentStartDate.date,
                    paymentEndDate: this.paymentEndDate.date,
                    placementDeadlineStartDate : this.placementDeadlineStartDate.date,
                    placementDeadlineEndDate : this.placementDeadlineEndDate.date,
                    placementExpiryStartDate : this.placementExpiryStartDate.date,
                    placementExpiryEndDate : this.placementExpiryEndDate.date,
                    invoiceDueStartDate : this.invoiceDueStartDate.date,
                    invoiceDueEndDate : this.invoiceDueEndDate.date,
                    paymentAdvertStartDate : this.paymentAdvertStartDate.date,
                    paymentAdvertEndDate : this.paymentAdvertEndDate.date,
                },
                headers: {
                    'Content-Type':'application/json',
                    'Accept': 'application/json',
                    'Authorization': localStorage.getItem('token')          
                }
            })
            .then((response) =>{
                let blob = new Blob([response.data], { type:'application/xlsx' } );
                let link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = (this.booking_for == 'affiliate') ? 'Artwork-Report.xlsx' : 'Payment-Report.xlsx';
                link.click();
            })
            .catch((error) =>{
                this.$store.dispatch('setLoadStatus')
                this.$notify({
                    type: 'error',
                    title: "The given data was invalid."
                });
            }).finally(() => {
                this.$store.dispatch('setLoadStatus')
            });
        },
    }
}
</script>

<style lang="scss" scoped>

</style>